import HelpCenterLayout from "@components/helpCenter/HelpCenterLayout"
import { SUPPORT_EMAIL } from "@helpers/helpCenterResult"
import {
  ArrowUturnLeftIcon,
  ChatBubbleLeftRightIcon,
  ChevronRightIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline"
import { ComponentType, ReactNode, SVGProps } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

function OptionRow({
  children,
  icon: Icon,
}: {
  children: ReactNode
  icon: ComponentType<SVGProps<SVGSVGElement>>
}) {
  return (
    <>
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-tile bg-vm-primary-soft text-vm-primary-text">
        <Icon aria-hidden="true" className="h-5 w-5" />
      </span>

      <span className="grow text-[15px] font-semibold text-vm-ink">
        {children}
      </span>

      <ChevronRightIcon
        aria-hidden="true"
        className="h-5 w-5 shrink-0 text-vm-muted"
      />
    </>
  )
}

export default function HelpCenterPage() {
  const { t } = useTranslation()

  const rowClassName =
    "vm-row transition-colors hover:bg-vm-primary-soft/50 focus:outline-none focus-visible:bg-vm-primary-soft"

  return (
    <HelpCenterLayout>
      <h1 className="vm-heading animate-fade-up">
        {t("pages.helpCenter.heading")}
      </h1>

      <nav className="vm-card animate-fade-up overflow-hidden [animation-delay:80ms]">
        <a className={rowClassName} href={`mailto:${SUPPORT_EMAIL}`}>
          <OptionRow icon={ChatBubbleLeftRightIcon}>
            {t("pages.helpCenter.generalQuestionOrSuggestion")}
          </OptionRow>
        </a>

        <Link className={rowClassName} to="/help-center/cancelation">
          <OptionRow icon={XCircleIcon}>
            {t("pages.helpCenter.cancelSubscription")}
          </OptionRow>
        </Link>

        <Link className={rowClassName} to="/help-center/refund">
          <OptionRow icon={ArrowUturnLeftIcon}>
            {t("pages.helpCenter.requestRefund")}
          </OptionRow>
        </Link>
      </nav>
    </HelpCenterLayout>
  )
}
